import expandArrows from '#app/assets/images/icons/arrow-expand-round.svg'
import building from '#app/assets/images/icons/building-06.svg'
import paperCheck from '#app/assets/images/icons/file-validation.svg'
import charningLaptop from '#app/assets/images/icons/laptop-charging.svg'
import moneyShield from '#app/assets/images/icons/money-security.svg'
import usersDatabase from '#app/assets/images/icons/user-list.svg'

interface FunctionalIconProps {
	variant:
		| 'money-shield'
		| 'paper-check'
		| 'building'
		| 'expand-arrows'
		| 'charning-laptop'
		| 'users-database'
}

export function FunctionalIcon({ variant }: FunctionalIconProps) {
	switch (variant) {
		case 'money-shield':
			return (
				<img
					src={moneyShield}
					alt="Icono de seguridad monetaria"
					className="h-8 w-8"
				/>
			)
		case 'paper-check':
			return (
				<img
					src={paperCheck}
					alt="Icono de verificación de documentos"
					className="h-8 w-8"
				/>
			)
		case 'building':
			return <img src={building} alt="Icono de edificio" className="h-8 w-8" />
		case 'expand-arrows':
			return (
				<img
					src={expandArrows}
					alt="Icono de flechas expandiéndose"
					className="h-8 w-8"
				/>
			)
		case 'charning-laptop':
			return (
				<img
					src={charningLaptop}
					alt="Icono de laptop cargando"
					className="h-8 w-8"
				/>
			)
		case 'users-database':
			return (
				<img
					src={usersDatabase}
					alt="Icono de base de datos de usuarios"
					className="h-8 w-8"
				/>
			)
		default:
			return null
	}
}
